import { reportSettlementsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SETTLEMENTS_REPORT_FILTERS,
  RESTORE_INITIAL
} = reportSettlementsTypes;

const getInitialState = () => ({
  startDate: newDate(),
  endDate: newDate(),
  station: null,
});

export const reportSettlementsReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case SET_SETTLEMENTS_REPORT_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return getInitialState();

    default:
      return state;
  }
};
